import React from 'react';

type Props = React.SVGAttributes<SVGElement>;

function Icon(props: Props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.30464 0.773522C3.82421 0.769531 0 4.49928 0 9.44652V19.2311H3.18089V9.43999C3.18089 4.83848 6.63805 1.55604 10.1045 0.84499C10.2475 0.814516 10.4133 0.769531 10.2475 0.769531L9.30464 0.773522Z"
        fill="currentColor"
      />
      <path
        d="M8.60796 1.94393C9.04021 1.66162 9.50581 1.43595 9.99368 1.27228C10.5549 1.06381 11.1475 0.956466 11.745 0.95507C12.0667 0.960045 12.3877 0.985869 12.7061 1.03239C12.9193 1.0631 13.168 1.11187 13.3219 1.14655C17.5302 2.13903 20 5.4734 20 9.63116V19.2311H16.8423V9.38114C16.8303 6.51898 14.7002 4.1489 11.9035 3.685C11.5671 3.62311 11.2255 3.59587 10.8837 3.60371C9.81353 3.62611 8.83607 4.00655 8.18833 4.77538C9.35659 4.30348 10.6548 4.28541 11.8353 4.72461C13.0159 5.16381 13.9961 6.02955 14.5889 7.15666C14.9793 7.90174 15.1832 8.73311 15.1827 9.57732V19.2271H12.0229V9.57624C12.0232 9.2869 11.9605 9.00109 11.8391 8.73938C11.7178 8.47767 11.5409 8.24659 11.3211 8.06278L10.0775 9.57624L8.83038 8.06278C8.61103 8.24683 8.4345 8.478 8.31347 8.73969C8.19245 9.00137 8.12993 9.28706 8.13042 9.57624V19.2271H4.97737V9.45846C4.97737 9.38114 4.97986 9.30418 4.98235 9.22759L4.98238 9.22649C4.98486 9.14992 4.98732 9.07365 4.98732 8.99672C5.09 6.27872 6.17833 3.47147 8.60796 1.94393Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Icon;
